import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-show-map",
  "use": "icon-show-map-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-show-map\"><path d=\"m13.4 3.7-3-1.5c-.1-.1-.3-.1-.4-.1s-.3 0-.4.1L6.4 3.8c-.1 0-.2.1-.4.1s-.3 0-.4-.1L3.4 2.7c-.1 0-.3-.1-.4-.1-.5 0-1 .4-1 1v7.8q0 .6.6.9l3 1.5c.1.1.3.1.4.1s.3 0 .4-.1l3.1-1.6c.1-.1.3-.1.4-.1s.3 0 .4.1l2.1 1.1c.1.1.3.1.4.1.5 0 1-.4 1-1V4.6c.2-.4 0-.7-.4-.9M3 3.6l2.1 1.1c.1.1.3.1.4.1v7.8L3 11.4zm3.5 9V4.8c.1 0 .3-.1.4-.1l2.6-1.3v7.8c-.1 0-.3.1-.4.1zm6.5-.2-2.1-1.1c-.1-.1-.3-.1-.4-.1V3.4L13 4.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol